module.exports = __webpack_public_path__ + "img/card2.d1b9178f.png";